export const site = {
  brand: 'Full Tienda',
  domain: 'fulltienda.online',
  instagram: '@fulltiendaok',
  instagramUrl: 'https://instagram.com/fulltiendaok',
  email: 'soporte.fulltiendaa@gmail.com',
  checkoutUrl: 'https://sistema-de-ahorro.impultienda.ar/checkout'
};
export const pricing = {
  price: '$19.990',
  listPrice: '$89.990',
  discount: '78% OFF',
  saving: '$70.000'
};
export const heroImage = 'https://cdn.magicpatterns.com/uploads/9Yvp55UaZy7dwGx7sYCpgc/ChatGPT_Image_16_sept_2026,_01_05_25_p.m..png';
export const bonusImage = 'https://cdn.magicpatterns.com/uploads/oucJja8AirVgQ4UZgY6k6A/ChatGPT_Image_16_sept_2026,_06_22_57_p.m..png';
export type PainSlide = {
  stage: string;
  title: string;
  copy: string;
  image: string;
  alt: string;
  tone: 'dolor' | 'cambio' | 'resultado';
};
export const painSlides: PainSlide[] = [{
  stage: 'Etapa 1',
  title: 'Llega fin de mes y no sabés a dónde se fue la plata',
  copy: 'Las facturas apiladas, las cuotas que se acumulan y un saldo en rojo que ya no sorprende. Trabajás todo el mes y aún así no te alcanza. No es que ganes poco: es que nadie te enseñó a ordenar lo que entra.',
  image: 'https://cdn.magicpatterns.com/uploads/v62vk8cm7tRjFx8Wa9yVq9/ChatGPT_Image_16_sept_2026,_12_24_02_a.m..png',
  alt: 'Hombre preocupado de noche revisando facturas y un saldo negativo en la computadora',
  tone: 'dolor'
}, {
  stage: 'Etapa 2',
  title: 'Empezás a registrar y aparece la verdad de tus gastos',
  copy: 'Con el método de los 4 bolsillos anotás cada peso apenas entra. En la primera semana ya ves las fugas: los delivery, las suscripciones, las compras "chicas" que se comen tu sueldo.',
  image: 'https://cdn.magicpatterns.com/uploads/7Bfwc8ruXhKSoqZxYRZNLE/ChatGPT_Image_16_sept_2026,_12_23_22_a.m..png',
  alt: 'Hombre en la cocina anotando el total de las compras del supermercado en un cuaderno',
  tone: 'cambio'
}, {
  stage: 'Etapa 3',
  title: 'Tu dinero deja de decidir por vos',
  copy: 'Gastos cubiertos, deudas bajando y un fondo de emergencia que crece todos los meses. Abrís tu planilla, ves el saldo real y por primera vez el mes que viene ya está resuelto.',
  image: 'https://cdn.magicpatterns.com/uploads/x52n9bEDt5T2qDLFzCn3u8/ChatGPT_Image_16_sept_2026,_12_23_10_a.m..png',
  alt: 'Hombre tranquilo revisando su sistema de ahorro y presupuesto mensual en la computadora',
  tone: 'resultado'
}];
export const tomos = [{
  n: '01',
  title: "Poné en orden\ntu dinero",
  copy: 'Cómo registrar todo sin volverte loco y detectar en días las fugas que te dejan sin plata.'
}, {
  n: '02',
  title: "Ahorrá aunque\nganes poco",
  copy: "El corazón del sistema: Métodos realistas para crear margen,\nsostener el hábito y proteger tus metas"
}, {
  n: '03',
  title: "Deudas bajo\ncontrol",
  copy: "Un método para entender el costo,\nelegir prioridades y recuperar margen"
}, {
  n: '04',
  title: "Construí tu fondo\nde emergencia",
  copy: 'Orden de pago de deudas, cómo negociar y qué hacer para no volver a financiar el día a día.'
}, {
  n: '05',
  title: 'Estrategia de inversión',
  copy: "Aprendé a evaluar inversiones, controlar\nel riesgo y decidir sin improvisar."
}, {
  n: '06',
  title: "Diseñá tu plan\nfinanciero",
  copy: "Integrá tus metas, protegé los avances\ny construí un sistema para cada etapa."
}];
export const bonuses = [{
  title: "Reto 30 días",
  copy: "Calendario diario con acciones breves, seguimiento y casilleros para completar."
}, {
  title: "Planillas 4 Bolsillos",
  copy: "Presupuesto mensual, registro de gastos, distribución del ingreso y cierre del mes."
}, {
  title: "Calendario anual de gastos previsibles",
  copy: 'Nunca más un vencimiento olvidado ni un recargo por pagar tarde.'
}, {
  title: "Kit para salir de deudas sin desordenar tu vida",
  copy: "Inventario, matriz de prioridades, calendario de pagos y modelos para solicitar información o negociar."
}, {
  title: "Calculadora práctica del fondo de emergencia",
  copy: "Ejercicios para calcular la reserva según gastos esenciales, ingresos variables, personas a cargo y riesgos."
}, {
  title: "Planner financiero de 12 meses",
  copy: "El bonus más completo: objetivos, revisiones mensuales, patrimonio, ahorro, inversiones y balance anual."
}];
export const risks = [{
  n: '01',
  title: 'Llegás a fin de mes sin saber dónde quedó tu dinero',
  copy: 'Pagás cuentas, hacés compras y cubrís gastos cotidianos, pero cuando revisás el saldo no podés explicar con claridad en qué se fue todo.'
}, {
  n: '02',
  title: 'Intentás ahorrar, pero siempre aparece otro gasto',
  copy: 'Separás dinero con buenas intenciones, aunque terminás utilizándolo porque no anticipaste pagos, vencimientos o gastos previsibles.'
}, {
  n: '03',
  title: 'Tomás decisiones basándote en suposiciones',
  copy: 'Sin números actualizados, podés creer que tenés dinero disponible cuando en realidad ya está comprometido para cuotas, servicios o deudas.'
}, {
  n: '04',
  title: 'Tus deudas avanzan más rápido que tu plan',
  copy: 'Pagás cuotas todos los meses, pero no visualizás cuánto falta, cuánto disminuyó el saldo ni qué obligación deberías priorizar.'
}, {
  n: '05',
  title: 'Abandonás el presupuesto después de pocos días',
  copy: 'Las anotaciones quedan dispersas entre papeles, aplicaciones y cuentas mentales. Al no tener un sistema simple, mantener el control se vuelve agotador.'
}, {
  n: '06',
  title: 'Sentís preocupación cada vez que revisás tus finanzas',
  copy: 'La falta de claridad genera ansiedad, culpa y la sensación de que nunca vas a poder organizarte, incluso cuando estás haciendo un esfuerzo real.'
}];
export const faqs = [{
  q: '¿Sirve si gano poco?',
  a: 'Sí. El sistema está pensado justamente para ingresos ajustados: primero ordena lo que ya entra y recién después escala el ahorro. No necesitás ganar más para empezar.'
}, {
  q: '¿Cómo lo recibo?',
  a: 'Es 100% digital. Al confirmar el pago recibís por correo el acceso a los 6 tomos en PDF y a los 6 bonus. Podés leerlo desde el celular, la compu o imprimirlo.'
}, {
  q: '¿Necesito conocimientos previos?',
  a: 'Ninguno. Está escrito en lenguaje simple, con ejemplos concretos y planillas ya armadas. Si sabés sumar, podés aplicarlo.'
}, {
  q: '¿Cuánto tardo en ver resultados?',
  a: 'La mayoría detecta sus primeras fugas de dinero en la primera semana de registro. El plan completo está diseñado para 12 meses.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tenés 7 días de garantía. Escribinos a soporte.fulltiendaa@gmail.com y te devolvemos el 100% del dinero, sin preguntas.'
}];